import React from 'react';

interface Props { size?: number; stroke?: string; glyphOpacity?: number; }

/**
 * Canonical Dagrun vertical-rune icon. Used in NavBar lockup + other branding.
 * Render white-on-brand by default; override via stroke/glyphOpacity.
 */
export default function DagrunIcon({ size = 20, stroke = 'white', glyphOpacity = 0.14 }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <line x1="24" y1="3"  x2="24" y2="45" stroke={stroke} strokeWidth="2.2" strokeLinecap="square"/>
      <line x1="18" y1="3"  x2="30" y2="3"  stroke={stroke} strokeWidth="2.2" strokeLinecap="square"/>
      <line x1="18" y1="45" x2="30" y2="45" stroke={stroke} strokeWidth="2.2" strokeLinecap="square"/>
      <path d="M24 12 L10 24 L24 36 L38 24 Z" fill={stroke} opacity={glyphOpacity}/>
      <line x1="24" y1="12" x2="10" y2="24" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="10" y1="24" x2="24" y2="36" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="24" y1="12" x2="38" y2="24" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="38" y1="24" x2="24" y2="36" stroke={stroke} strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="24" cy="24" r="6"   stroke={stroke} strokeWidth="1.8" fill="none" opacity="0.55"/>
      <circle cx="24" cy="24" r="2.5" fill={stroke}/>
    </svg>
  );
}
